'use client';

import { useTranslations } from 'next-intl';
import { ReviewListing } from './review-listing';
// import { ReviewMetrics } from './review-metrics';

export function ReviewPageContent() {
  const t = useTranslations('review');

  return (
    <div className='space-y-6'>
      <h1 className='text-2xl font-bold tracking-tight'>{t('pageTitle')}</h1>

      {/* <ReviewMetrics /> */}
      <ReviewListing />
    </div>
  );
}
